import React from 'react';
import { useState } from "react";
import { PrismicRichText } from "@prismicio/react";
import Calculator from "../calculator";
import ScriptInjector from "../script-injector";

const QuoteSlider = (props) => {

    const sc = props.slice.primary;

    let space = sc.spacing;

    if (space === "Both large") {
        space = "gutter";
    } else if (space === "Both small") {
        space = "gutter sm";
    } else if (space === "Top large") {
        space = "gutter bot";
    } else if (space === "Top small") {
        space = "gutter bot sm";
    } else if (space === "Bottom large") {
        space = "gutter top";
    } else {
        space = "gutter top sm";
    }

    let bg =
        sc.background === "gradient"
        ? "gradient-to-b from-grey-light to-white"
        : sc.background === "grey"
        ? "grey-light"
        : sc.background === "dark grey"
        ? "grey-d"
        : sc.background;

    let layout = sc.layout === "Left" ? "md:flex-row" : "md:flex-row-reverse";

    const anchor = sc.section_title.text.replace(/\s+/g, "-").toLowerCase();

    const [form, showForm] = useState(false)

      

    return (
        <section className={"relative bg-" + bg + " " + sc.theme + " " + space} id={anchor}>
            <div className={"wrapper flex flex-col justify-between gap-6 md:gap-24 " + layout}>
            <div className="w-full md:w-1/2 content-side">
                <div className="label bg-opacity-10 font-bold uppercase tracking-widest text-xs mb-1 md:mb-2 text-accessible-green">{sc.label}</div>
                <PrismicRichText field={sc.section_title.richText} />
                <PrismicRichText field={sc.content.richText} />
                {sc.custom_code ? <ScriptInjector html={sc.custom_code} /> : "" }
            </div>

                <Calculator 
                    className="quote-slider w-full md:w-1/2 self-start"
                    buttonText={sc.text}
                    formId={sc.form}
                    showForm={form}
                    onFormToggle={showForm}
                />
                </div>
        </section>
    );
}

export default QuoteSlider;
